import React, { useEffect, useState } from "react";
import { settingRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { Button, Card, NotConnected, PageHead, Switch } from "../../components/ui";
import { useAsync } from "../../components/ui";

const CHANNELS = [
  { key: "line", name: "LINE" },
  { key: "email", name: "อีเมล" , nameEn: "Email" },
  { key: "sms", name: "SMS" },
];

export default function NotificationSettings() {
  const { orgId, toast } = useApp();
  const { tx } = useI18n();
  const { data } = useAsync(() => settingRepo.getOrgNotificationSettings(orgId), [orgId], null);
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  if (!form) return null;

  const toggleEvent = (key) =>
    setForm((prev) => ({ ...prev, events: prev.events.map((event) => (event.key === key ? { ...event, enabled: !event.enabled } : event)) }));

  const save = async () => {
    setSaving(true);
    try {
      await settingRepo.saveOrgNotificationSettings(orgId, form);
      toast(tx("บันทึกการตั้งค่าแจ้งเตือนเรียบร้อย", "Notification settings saved"), "success");
    } catch (err) {
      toast(err.message || tx("บันทึกการตั้งค่าไม่สำเร็จ", "Failed to save settings"), "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <PageHead title={tx("ตั้งค่าการแจ้งเตือน", "Notification settings")} subtitle={tx("เลือกเหตุการณ์ที่ต้องการแจ้งเตือน (ตั้งค่าแยกต่อร้าน)", "Choose which events to notify (per shop)")} actions={<Button variant="primary" onClick={save} disabled={saving}>{tx("บันทึก", "Save")}</Button>} />

      <Card title={tx("ช่องทางแจ้งเตือน", "Notification channels")}>
        {CHANNELS.map((channel) => (
          <div key={channel.key} className="u-between" style={{ padding: "9px 0", borderBottom: "1px solid var(--c-slate-100)" }}>
            <span className="u-fs-14">{tx(channel.name, channel.nameEn || channel.name)}</span>
            <NotConnected />
          </div>
        ))}
        <div className="field-hint u-mt-16">{tx("ยังไม่มีการส่งแจ้งเตือนออกนอกระบบ (LINE Notify ปิดให้บริการแล้ว) — การเปิด/ปิดเหตุการณ์ด้านล่างจะถูกเก็บไว้ใช้เมื่อเชื่อมต่อช่องทางแล้ว", "Outbound notifications are not sent yet (LINE Notify has shut down) — the event toggles below are kept for when a channel is connected")}</div>
      </Card>

      <Card title={tx("เหตุการณ์ที่แจ้งเตือน", "Notification events")}>
        {form.events.map((event) => (
          <div key={event.key} className="u-between" style={{ padding: "9px 0", borderBottom: "1px solid var(--c-slate-100)" }}>
            <span className="u-fs-14">{event.name}</span>
            <Switch checked={event.enabled} onChange={() => toggleEvent(event.key)} />
          </div>
        ))}
      </Card>
    </>
  );
}
